<template>
    <div>
        <modal class="payment-all" :display="modalStatus.bizPaymentAll" @modalStatus="closeModal" >
            <alarm-msg-white type="ERROR" :msg="alarm.error.msg" :count="alarm.error.count" :showAlarm="alarm.error.status" @timeOut="alarm.error.status=false"></alarm-msg-white>
            <h1>委託付款</h1>
            <div class="payment-all-wrap">
                    <div class="list">
                        <div class="title">
                            待付款總額：
                        </div>
                        <div class="content orange">
                            {{toCurrency(unpaidAmountTotal)}}
                        </div>
                    </div>
                    <div class="list">
                        <div class="title">
                            付款方式：
                        </div>
                        <div class="content">
                            <div class="wallet">
                                <div class="wrap">
                                    <img src="@/assets/img/icon/wallet_orange.svg" alt="" srcset="">
                                    <div class="content-wrap">
                                        <div class="title">
                                            飛豬錢包
                                        </div>
                                        <div class="description">
                                            錢包餘額：{{toCurrency(userBalance)}}
                                        </div>
                                    </div>
                                </div>
                                <span class="balance-not-enough" v-if="balanceNotEnough">
                                    <img src="@/assets/img/icon/alarm_msg_error.svg" alt="">
                                    {{balanceNotEnough}}
                                </span>
                            </div>
                            
                        </div>
                    </div>
                    <div class="list">
                        <div class="title">
                            扣款項目：
                        </div>
                        <div class="content">
                            委託獎金待付款總額
                        </div>
                    </div>
                    <div class="list">
                        <div class="title">
                            扣款金額：
                        </div>
                        <div class="content">
                            {{toCurrency(unpaidAmountTotal)}}
                        </div>
                    </div>
            </div>
            <div class="btn-group">
                <div class="loading-wrap">
                    <btn-loading v-if="disabledState"></btn-loading>
                    <button class="default-button confirm" :disabled="disabledState" @click="paymentAll">確認扣款</button>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import alarmMsgWhite from '@/components/bussiness/widges/alarms/alarmMsgWhite.vue';
import btnLoading from '@/components/bussiness/widges/btnLoading.vue';
import { mapGetters } from 'vuex'

import { 
    apiBizPaymentAll
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            balanceNotEnough: null,
            disabledState: false,
            alarm: {
                success:{
                    status: false,
                    msg: null,
                    count: 3000
                },
                error:{
                    status: false,
                    msg: null,
                    count: 3000
                }
            },
        }
    },
    methods: {
        paymentAll: function () {
            this.$analyticsBiz.logEvent('一鍵付款', { screen_name: '一鍵付款'})
            if(parseFloat(this.userBalance) > parseFloat(this.unpaidAmountTotal)){
                this.disabledState = true
                apiBizPaymentAll()
                .then( res => {
                    console.log(res)
                    if(res.data.status == 'SUCCESS'){
                        this.$store.dispatch('setAlarmStatus', {status: true,title: '一鍵付款成功',type: 'success'})
                        this.$store.dispatch('getBizTaskUnpaidMgtList', 1)
                        this.disabledState = false
                        this.closeModal()
                    }else{
                        this.disabledState = false
                        this.alarm.error.msg = '一鍵付款失敗'
                        this.alarm.error.status = true
                    }
                }).catch( err => {
                    console.log(err)
                })
            }else{
                this.balanceNotEnough = '餘額不足'
            }
            
        },
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizPaymentAll'})
        },
    },
    computed: {
        isOpen: function () {
            if(this.value){
                return '開啟'
            }else{
                return '關閉'
            }
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
            unpaidAmountTotal: 'GET_BIZ_TASK_UNPAID_MGT_UNPAID_AMOUNG_TOTAL',
            userBalance: 'GET_BIZ_TASK_UNPAID_MGT_WALLET_BALANCE'
        })
    },
    components: {
        Modal,
        alarmMsgWhite,
        btnLoading
    }
}
</script>
<style lang="scss"  >
    #modal.payment-all{
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                .alarm-msg{
                    left: 50%;
                    margin-left: -70px;
                }
                >h1{
                    margin-top: 32px;
                    margin-bottom: 24px;
                }
                .payment-all-wrap{
                    padding: 0 32px 8px 32px;
                    .list{
                        width: 390px;
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;
                        >.title{
                            width: 84px;
                            margin-right: 4px;
                            text-align: right;
                        }
                        >.content{
                            &.orange{
                                color: #ff9275;
                                font-size: 20px;
                            }
                            .wallet{
                                position: relative;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                                .wrap{
                                    min-width: 222px;
                                    box-sizing: border-box;
                                    position: relative;
                                    display: flex;
                                    align-items: center;
                                    padding: 0 20px;
                                    height: 90px;
                                    border-radius: 4px;
                                    line-height: 1.71;
                                    margin-right: 16px;
                                    cursor: pointer;
                                    border: solid 1px #ff9275;
                                    background-color: #fff;
                                    color: #ff9275;
                                    margin-bottom: 9px;
                                    img{
                                        margin-right: 10px;
                                    }
                                    .content-wrap{
                                        .description{
                                            font-size: 12px;
                                            color: #292625;
                                        }
                                    }
                                }
                                .balance-not-enough{
                                    position: relative;
                                    font-size: 16px;
                                    font-weight: 500;
                                    color: #fc7171;
                                    display: flex;
                                    align-items: center;
                                    img{ 
                                        margin-right: 8px;
                                        width: 16px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                .loading-wrap{
                    position: relative;
                    width: 184px;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button.confirm{
                        margin-right: 16px;
                    }
                    .btn-loading{
                        left: 134px;
                        top: 6px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/paymentAll.vue